"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFontToCssVar = void 0;
var betting_events_1 = __importDefault(require("@gin-betting/betting-events"));
var locale_manager_1 = __importDefault(require("@gin-betting/locale-manager"));
var types_1 = require("@sentry/types");
var utils_1 = require("../utils");
var sentryHub_1 = __importDefault(require("./sentryHub"));
var BettingEvents = betting_events_1.default.BettingEvents;
var sendSentryError = function (error, message) {
    sentryHub_1.default.withScope(function (scope) {
        scope.setLevel(types_1.Severity.Warning);
        scope.setExtras(error);
        scope.setTag('BettingAPI', 'loadFonts');
        sentryHub_1.default.captureException(message);
    });
};
var BettingAPI = /** @class */ (function () {
    function BettingAPI(_a) {
        var fonts = _a.fonts, bettingSettings$ = _a.bettingSettings$, requiredCallbacks = _a.requiredCallbacks;
        this.isInitialized = false;
        this.isLoadedFonts = false;
        this.bettingEvents$ = new BettingEvents();
        if (typeof window !== 'undefined') {
            window.__app.version = __VERSION__;
            window.__app.initialTitle = document.title;
        }
        var staticEndpoint = utils_1.getBettingOptions().url.staticEndpoint;
        if (process.env.NODE_ENV === 'production' && staticEndpoint) {
            __webpack_public_path__ = staticEndpoint + "/";
        }
        this.bettingSettings$ = bettingSettings$;
        this.requiredCallbacks = requiredCallbacks;
        this.fonts = fonts;
        this.init = this.init.bind(this);
        this.registerCallbacks = this.registerCallbacks.bind(this);
        this.setBettingSetting = this.setBettingSetting.bind(this);
        this.getBettingSetting = this.getBettingSetting.bind(this);
        this.subscribeOnBettingSetting = this.subscribeOnBettingSetting.bind(this);
        this.subscribe = this.subscribe.bind(this);
    }
    BettingAPI.prototype.init = function () {
        var _this = this;
        if (this.isInitialized)
            return;
        this.isInitialized = true;
        if (typeof window === 'undefined') {
            return;
        }
        var _a = utils_1.getBettingOptions(), locale = _a.locale, rootElement = _a.rootElement;
        var rootEl = document.getElementById(rootElement);
        this.setupFonts();
        if (!rootEl) {
            throw new Error("Root element with id:\"" + rootElement + "\" not found!");
        }
        document.body.classList.add("__app--is-locale-" + locale);
        rootEl.classList.add('__app--is-betting');
        if (window.bettingLoader.__getLocale) {
            window.bettingLoader.__getLocale.then(function (extensions) {
                locale_manager_1.default.setExtensions(extensions);
                _this.renderDOM(rootEl);
            });
        }
    };
    BettingAPI.prototype.registerCallbacks = function (callbacks) {
        var validationError = validateBettingCallbacks(callbacks, this.requiredCallbacks);
        if (validationError) {
            console.error(validationError);
            return;
        }
        this.setBettingSetting('callbacks', callbacks);
    };
    BettingAPI.prototype.setBettingSetting = function (key, value) {
        var _a;
        // TODO: store prevBettingSettings to prevent trigger handler on change
        this.bettingSettings$.next(__assign(__assign({}, this.bettingSettings$.getValue()), (_a = {}, _a[key] = value, _a)));
    };
    BettingAPI.prototype.getBettingSetting = function (key) {
        return this.bettingSettings$.getValue()[key];
    };
    BettingAPI.prototype.subscribeOnBettingSetting = function (key, handler) {
        var subscription = this.bettingSettings$
            // TODO: add validation on equal with previous value. should not trigger handler on change other keys.
            .filter(function (bettingSettings) { return key in bettingSettings; })
            .map(function (bettingSettings) { return bettingSettings[key]; })
            .subscribe(function (setting) { return handler(setting); });
        return function () {
            subscription.unsubscribe();
        };
    };
    BettingAPI.prototype.subscribe = function (eventType, handler) {
        return this.bettingEvents$.subscribe(eventType, handler);
    };
    BettingAPI.prototype.setupFont = function (family, suffix) {
        var isFontExist = document.fonts.check("1em " + family);
        if (isFontExist) {
            setFontToCssVar(family, suffix);
        }
        else {
            var _a = this.fonts[suffix], defaultFontFamily = _a[0], defaultFont = _a[1];
            var isDefault = family === defaultFontFamily;
            if (isDefault) {
                var staticEndpoint_1 = utils_1.getBettingOptions().url.staticEndpoint;
                var font = defaultFont.map(function (f) { return (__assign(__assign({}, f), { source: f.source.replace(/url\(/g, "url(" + staticEndpoint_1 + "/") })); });
                loadFont({
                    font: font,
                    suffix: suffix,
                });
            }
            else {
                var errorMessage = family + " not found";
                sendSentryError(null, errorMessage);
                console.error(errorMessage);
            }
        }
    };
    BettingAPI.prototype.setupFonts = function (primaryFont, secondaryFont) {
        if (primaryFont === void 0) { primaryFont = this.fonts.primary[0]; }
        if (secondaryFont === void 0) { secondaryFont = this.fonts.secondary[0]; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.isLoadedFonts)
                    return [2 /*return*/];
                this.isLoadedFonts = true;
                this.setupFont(primaryFont, 'primary');
                this.setupFont(secondaryFont, 'secondary');
                return [2 /*return*/];
            });
        });
    };
    return BettingAPI;
}());
function loadFont(_a) {
    var font = _a.font, suffix = _a.suffix;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all(font.map(function (_a) {
                        var family = _a.family, source = _a.source, descriptors = _a.descriptors;
                        return new FontFace(family, source, descriptors)
                            .load()
                            .then(function (f) { return document.fonts.add(f); })
                            .catch(function (error) {
                            sendSentryError(error, 'Failed to load default fonts');
                        });
                    })).then(function () {
                        setFontToCssVar(font[0].family, suffix);
                    })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function validateBettingCallbacks(callbacks, names) {
    if (!callbacks || typeof callbacks !== 'object') {
        return new Error('Invalid argument "callbacks"');
    }
    var errors = names.reduce(function (acc, name) {
        if (typeof callbacks[name] !== 'function') {
            acc.push("Invalid argument \"callbacks." + name + "\"");
        }
        return acc;
    }, []);
    if (errors.length > 0) {
        return new Error('\n' + errors.join('\n'));
    }
}
function setFontToCssVar(font, suffix) {
    document.documentElement.style.setProperty("--app-font-family-" + suffix, font + ", sans-serif");
}
exports.setFontToCssVar = setFontToCssVar;
exports.default = BettingAPI;
//# sourceMappingURL=BettingAPI.js.map